import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_CORRELATION_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/providers/fp-correlation-tab-connect-services.token';
import { FpCorrelationSummaryConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/services/fp-correlation-summary-connect.service';
import { FpCorrelationSummaryStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/services/fp-correlation-summary/fp-correlation-summary.store';

export function fpCorrelationSummaryProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpCorrelationSummaryStore,
    FpCorrelationSummaryConnectService,
    {
      provide: FP_CORRELATION_TAB_CONNECT_SERVICES,
      useExisting: FpCorrelationSummaryConnectService,
      multi: true,
    },
  ];
}
